import Vue from 'vue'
import VueRouter from 'vue-router'
import resize from '@/utils/resize'
import PcRoute from './pc'
import MdRoute from './md'
import store from '../store'
Vue.use(VueRouter)

const isMd = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)

Vue.use(resize)
const routes = isMd ? MdRoute : PcRoute

console.log(isMd ? '移动端' : 'PC端');
const router = new VueRouter({
  routes
})

const whiteList = ['/login','/manage/noPermission','/manageHome','/Home']
router.beforeEach((to, from, next) => {
  // 白名单
  if (localStorage.getItem('UserAdmin')) {
      if (!isMd) {
        // pc端 用户可访问页面设置
        if(store.getters.allMenu.length && !store.getters.hasPermissionMenu.length) {
          // allMenu中有表示已请求了menu数据 而hasPermissionMenu为空 则直接无任何权限
          if (whiteList.includes(to.path)) {
            next()
          } else {
            next("/manage/noPermission")
          }
        } else
          if (store.getters.allMenu.findIndex(item => item.path === to.path) > -1 && store.getters.hasPermissionMenu.findIndex(item => item.path === to.path) === -1){
          // allMenu中包含 此path 而 hasPermissionMenu 中不包含此path 则无权限访问
            if (to.path === '/manage' && store.getters.hasPermissionMenu.length) {
              next(store.getters.hasPermissionMenu[0].path)
            } else {
              next("/manage/noPermission")
            }
        } else {
            next()
        }
      } else {
        next()
      }
  } else {
    if (to.path === '/login') {
      next()
    } else {
      next('/login')
    }
  }
})

export default router
